import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SsoReauthConfirmationDialogData {
  providerName: string;
}

@Component({
  selector: 'app-sso-reauth-confirmation-dialog',
  templateUrl: './sso-reauth-confirmation-dialog.component.html',
  styleUrls: ['./sso-reauth-confirmation-dialog.component.scss']
})
export class SsoReauthConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SsoReauthConfirmationDialogData,
    private dialogRef: MatDialogRef<SsoReauthConfirmationDialogComponent>
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
